import { Routes } from 'react-router-dom';
import Loader from '../../../../../../shared/components/molecules/loader';
import { LOADING } from '../../../../../../shared/constants';
import { useLoadChatCache } from '../../../../../../shared/hooks/use-load-chat-cache';
import getRoutesV1 from './routes';
import { useAtomValue } from 'jotai';
import { isEmbedAtom } from '../../../../../embed/state';

const HomeMiddleware = () => {
  const loading = useLoadChatCache();
  const isEmbed = useAtomValue(isEmbedAtom);

  if (loading) {
    return <Loader size={32} secondary={LOADING} />;
  }

  return <Routes>{getRoutesV1({ isEmbed })}</Routes>;
};

export default HomeMiddleware;
